.c7{display:inline-flex;}